import { resolveAll } from '../../core/utils/promises';
import { getAuthCookie } from '../analytics/identity/auth.client';
import { getOrCreateCorrelationIdCookie } from '../analytics/identity/correlation.client';
import { refreshOrCreateDeviceIdCookie } from '../analytics/identity/device.client';
import { refreshOrCreateSessionCookie } from '../analytics/identity/session.client';
import type { CorrelationContext } from './context.schema';
import { baseContext, ObservabilityStrategy } from './observability';

async function getContext(): Promise<Partial<CorrelationContext>> {
	const [auth, correlationId, deviceId, sessionId] = await resolveAll(
		getAuthCookie(),
		getOrCreateCorrelationIdCookie(),
		refreshOrCreateDeviceIdCookie(),
		refreshOrCreateSessionCookie(),
	);

	const context = {
		...baseContext,
		correlationId: correlationId ?? undefined,
		deviceId: deviceId ?? undefined,
		sessionId: sessionId ?? undefined,
		userId: auth?.id ?? undefined,
	};

	return context;
}

async function init(): Promise<void> {
	ObservabilityStrategy.init();
	ObservabilityStrategy.addContext(await getContext());
}

init();
